var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.899,
    height: 29.899,
    viewBox: "0 0 29.899 29.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13483",
    "data-name": "Group 13483",
    transform: "translate(-1336.556 -323.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13439",
    "data-name": "Group 13439",
    transform: "translate(-380.266 121.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13136",
    "data-name": "Group 13136",
    transform: "translate(1716.822 201.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    fill: "none",
    stroke: "#9dacbd",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.95,
    cy: 14.95,
    r: 14.95,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.95,
    cy: 14.95,
    r: 13.95,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13441",
    "data-name": "Group 13441",
    transform: "translate(0.195 -0.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13440",
    "data-name": "Group 13440",
    transform: "translate(82.314 31.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    d: "M1261.778,471.225a2.276,2.276,0,0,1,.1-.28.912.912,0,0,1,.889-.524q3.062.005,6.123,0a.844.844,0,0,1,.111,0c.112.015.167-.033.212-.139a2.687,2.687,0,0,1,3.865-1.293,2.606,2.606,0,0,1,1.125,1.3.179.179,0,0,0,.2.135c.318-.006.636-.011.954,0a.894.894,0,0,1,.187,1.758,1.163,1.163,0,0,1-.283.031c-.286,0-.573.006-.859,0a.179.179,0,0,0-.2.135,2.652,2.652,0,0,1-2.534,1.67,2.611,2.611,0,0,1-2.443-1.636.24.24,0,0,0-.257-.17q-3.006.007-6.012,0c-.742,0-.92-.121-1.179-.8Zm10.824.1a.9.9,0,1,0-.9.894A.9.9,0,0,0,1272.6,471.327Z",
    transform: "translate(0 -164.165)",
    fill: "#9dacbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    d: "M1261.778,301.714a2.665,2.665,0,0,1,.193-.5.811.811,0,0,1,.717-.371c.3,0,.594-.008.891,0,.13,0,.179-.045.23-.157a2.7,2.7,0,0,1,4.84-.282,1.338,1.338,0,0,1,.136.286c.039.125.112.152.236.152q3.126-.006,6.251,0a.887.887,0,0,1,.93.8.9.9,0,0,1-.814.99c-.063,0-.127,0-.191,0q-3.086,0-6.171,0a.222.222,0,0,0-.245.16,2.7,2.7,0,0,1-4.977-.014.2.2,0,0,0-.22-.146c-.275.009-.551,0-.827,0a.893.893,0,0,1-.954-.772c-.006-.03-.017-.06-.026-.089Zm4.519.927a.9.9,0,1,0,0-1.8.9.9,0,0,0,0,1.8Z",
    transform: "translate(0)",
    fill: "#9dacbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    d: "M1261.778,641a1.968,1.968,0,0,1,.089-.318.867.867,0,0,1,.811-.542c.313-.007.626,0,.938,0a.159.159,0,0,0,.175-.116,2.7,2.7,0,0,1,4.376-.943,2.434,2.434,0,0,1,.62.913.2.2,0,0,0,.222.146q3.125-.006,6.251,0a.9.9,0,0,1,.139,1.788c-.068.006-.138,0-.207,0q-3.078,0-6.155,0a.234.234,0,0,0-.259.166,2.693,2.693,0,0,1-4.322.923,2.539,2.539,0,0,1-.662-.96.165.165,0,0,0-.184-.127c-.281.006-.562,0-.843,0a.893.893,0,0,1-.965-.777c-.007-.031-.016-.06-.025-.091Zm3.622.028a.9.9,0,0,0,1.8.015.9.9,0,0,0-.893-.906A.891.891,0,0,0,1265.4,641.032Z",
    transform: "translate(0 -328.469)",
    fill: "#9dacbd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersTable);
export default __webpack_public_path__ + "static/media/filters-table.3863fbfa70ff9e1dd463e69faeaa2465.svg";
export { ForwardRef as ReactComponent };